import { Injectable } from '@angular/core';
import { Plane, Vector3 } from 'babylonjs';

@Injectable({
  providedIn: 'root',
})
export class AngleIronMathService {
  findCenterPoint(sample: Vector3, plane: Plane): Vector3 {
    const projected = sample.projectOnPlane(plane, sample.add(plane.normal));
    return Vector3.Center(projected, sample);
  }

  getNormals(centers: Vector3[], planes: Plane[]): [Vector3, Vector3] {
    const normalInner = centers[0].subtract(centers[1]).normalizeToNew();
    const normal = planes[0].isFrontFacingTo(normalInner, 0)
      ? planes[0].normal
      : planes[0].normal.negate();
    const otherNormal = planes[1].isFrontFacingTo(normalInner, 0)
      ? planes[1].normal.negate()
      : planes[1].normal;
    return [normal, otherNormal];
  }

  findProjectedEdges(centers: [Vector3, Vector3], planes: [Plane, Plane]): [Vector3, Vector3] {
    const projected = centers.map((center) => [
      this.doubleProjectOnPlanes(center, [planes[0], planes[1]]),
      this.doubleProjectOnPlanes(center, [planes[1], planes[0]]),
    ]);
    return [
      Vector3.Center(projected[0][0], projected[1][0]),
      Vector3.Center(projected[0][1], projected[1][1]),
    ];
  }

  doubleProjectOnPlanes(point: Vector3, planes: [Plane, Plane]): Vector3 {
    const tmp = point.projectOnPlane(planes[0], point.add(planes[0].normal));
    return tmp.projectOnPlane(planes[1], tmp.add(planes[1].normal));
  }

  minMaxVectors(picks: Vector3[]): { min: Vector3; max: Vector3 } {
    const min = picks[0].clone();
    const max = picks[0].clone();
    picks.forEach((pick) => {
      min.minimizeInPlace(pick);
      max.maximizeInPlace(pick);
    });
    return { min, max };
  }
}
